module.exports = __webpack_public_path__ + "img/tram.85c372b4.svg";